import { Flex, Loader } from "@mantine/core";
import { colors } from "../theme/colors";
import { IonContent, IonPage } from "@ionic/react";

export const FHLoader = () => {
  return (
    <IonPage>
      <IonContent>
        <Flex
          display="flex"
          w={"100%"}
          h={"100%"}
          align={"center"}
          justify={"center"}
        >
          <Loader
            data-testid="loader"
            size="lg"
            mt="xl"
            color={colors.primary}
          ></Loader>
        </Flex>
      </IonContent>
    </IonPage>
  );
};
